export default "__VITE_ASSET__B2V5XJxS__"